import { ResultsFilter } from '../types/results.types';

export interface ApiFilterParams {
  name?: string;
  min_rating?: number;
  max_rating?: number;
  min_reviews?: number;
  max_reviews?: number;
  has_website?: boolean;
  has_phone?: boolean;
  has_book_visit?: boolean;
  has_decision_makers?: boolean;
  has_email?: boolean;
  email_verification_status?: string;
  industries?: string;
  delivery_group?: 'website_confirmed' | 'additional';
  matched_offering?: string;
  google_ads_signal?: 'detected_recently' | 'no_ad_tracking';
}

export function convertFiltersToApiFormat(filters: ResultsFilter): ApiFilterParams {
  return {
    name: filters.searchTerm,
    min_rating: filters.minRating,
    max_rating: filters.maxRating,
    min_reviews: filters.minReviews,
    max_reviews: filters.maxReviews,
    has_website: filters.hasWebsite ?? undefined,
    has_phone: filters.hasPhone ?? undefined,
    has_book_visit: filters.hasBookVisit ?? undefined,
    has_decision_makers: filters.hasDecisionMakers ?? undefined,
    has_email: filters.hasEmail ?? undefined,
    email_verification_status: filters.emailVerificationStatus?.join(','),
    industries: filters.industry,
    delivery_group: filters.strongMatchesOnly ? 'website_confirmed' : undefined,
    matched_offering: filters.matchedOffering,
    google_ads_signal: filters.googleAdsSignal,
  };
}
